import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavItemPrimaryInterface, NavItemSecondaryInterface } from 'app/app-layout/models';
import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';
import { Observable } from 'rxjs';

import { NavItemsServiceInterface } from './nav-items-service.interface';

@Injectable()
export class NavItemsService implements NavItemsServiceInterface {

  constructor(private readonly _store: Store<AppStateInterface>) { }

  /**
   * Retrieve a list of available primary navigation items visible to the logged-in user.
   */
  public getPrimaryNavItems(): Observable<NavItemPrimaryInterface[]> {
    return this._store.select(({ navItems }: AppStateInterface) => navItems.primaryNavItems);
  }

  /**
   * Retrieve a list of available secondary navigation items visible to the logged-in user.
   */
  public getSecondaryNavItems(): Observable<{ [categoryId: string]: NavItemSecondaryInterface[] }> {
    return this._store.select(({ navItems }: AppStateInterface) => navItems.secondaryNavItems);
  }

}
